import { render } from "./adminDashboardView.vue?vue&type=template&id=5003d91b&scoped=true"
import script from "./adminDashboardView.vue?vue&type=script&lang=js"
export * from "./adminDashboardView.vue?vue&type=script&lang=js"

import "./adminDashboardView.vue?vue&type=style&index=0&id=5003d91b&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5003d91b"]])

export default __exports__